<template>
  <div class="inline">
    <a-button type="link" @click="show">查看</a-button>
    <a-modal :visible="visible" :width="1000" title="试卷预览" @ok="handleCancel" @cancel="handleCancel"
      :confirm-loading="loading">
      <template slot="footer">
        <a-button key="submit" type="primary" @click="handleCancel">
          关闭
        </a-button>
      </template>
      <a-form v-if="item.name">
        <a-row type="flex" justify="center">
          <a-col span="20">
            <a-form-item>
              <a-input disabled v-model="item.name" size="large" placeholder="试卷名称" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16" type="flex" justify="center">
          <a-col span="4" label="年级:">
            <a-input disabled v-model="item.gradename" size="large" placeholder="所属年级" />
          </a-col>
          <a-col span="4">
            <a-input disabled v-model="item.semestername" size="large" placeholder="所属学期" />
          </a-col>
          <a-col span="4">
            <a-input disabled v-model="item.typename" size="large" placeholder="试卷类型" />
          </a-col>
          <a-col span="6">
            <a-form-item>
              <a-radio-group disabled v-model="item.teacher_check_flag" button-style="solid">
                <a-radio-button :value="0">
                  不交叉批改
                </a-radio-button>
                <a-radio-button :value="1">
                  交叉批改
                </a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>

      <a-divider v-if="item.name"></a-divider>

      <a-list item-layout="vertical" :data-source="questionList">
        <a-list-item slot="renderItem" key="item.title" slot-scope="item">
          <a-list-item-meta>
            <div slot="title">
              <a-tag color="#87d068" style="float: left; margin-right: .5rem" v-if="item.typestr == 'ANSWER'">问答题
              </a-tag>
              <a-tag color="#87d068" style="float: left; margin-right: .5rem" v-if="item.typestr == 'PREVIEW'">预习题
              </a-tag>
              <a-tag color="#87d068" style="float: left; margin-right: .5rem" v-if="item.typestr == 'JUDGMENT'">判断题
              </a-tag>
              <a-tag color="#87d068" style="float: left; margin-right: .5rem" v-if="item.typestr == 'COMPLETION'">填空题
              </a-tag>
              <a-tag color="#87d068" style="float: left; margin-right: .5rem" v-if="item.typestr == 'VIDEO'">口述题
              </a-tag>
              <a-tag color="#87d068" style="float: left; margin-right: .5rem" v-if="item.typestr == 'SINGLE_CHOICE'">单选题
              </a-tag>
              <div v-html="item.title" />
            </div>
            <template slot="description">
              <a-row :gutter="16" v-if="item.typestr == 'SINGLE_CHOICE'">
                <a-col :span="6" v-for="option in item.options" :key="option.value">
                  <div class="option">
                    <label class="label">{{ option.keys }}:</label>
                    <div class="span" v-html="option.value" />
                  </div>
                </a-col>
              </a-row>
              <div>
                <span v-if="item.typestr == 'ANSWER' || item.typestr == 'VIDEO'">参考答案:</span>
                <span
                  v-if="item.typestr == 'JUDGMENT' || item.typestr == 'COMPLETION' || item.typestr == 'SINGLE_CHOICE'">答案:</span>
                <span>{{ item.answer }}</span>
              </div>
              <div>分值:{{ item.score }}</div>
            </template>
          </a-list-item-meta>
          <div>
            <a-rate :value="item.star"></a-rate>
            <a-divider type="vertical" v-if="item.tag.length > 0"></a-divider>
            <a-tag v-for="tag in item.tag" :key="tag" color="#2db7f5">{{ tag }}</a-tag>
            <a-divider v-if="item.previewvideo != ''" type="vertical"></a-divider>
            <template v-if="item.systag != 0">
              <a-tag color="#2db7f5">相似题</a-tag>
              <a-divider type="vertical" />
            </template>
            <or-preview v-if="item.previewvideo != ''" text="预习视频" :videoUrl="item.previewvideo" />
            <or-preview v-if="item.analysisvideo != ''" text="解析视频" :videoUrl="item.analysisvideo" />
            <template v-if="item.typestr == 'PREVIEW'">
              <a-divider type="vertical" />
              <a-button size="small" :loading="loading" type="primary" @click="getPreviewExtendProblems(item)">绑定检测题
              </a-button>
            </template>
          </div>
        </a-list-item>
      </a-list>
    </a-modal>

    <a-modal width="1000px" :visible="showPreviewProblemsVisible" title="绑定自我检测" @ok="changePreviewProblem"
      :destroyOnClose="true"
      @cancel="changePreviewProblemForm.problem_ids = undefined; showPreviewProblemsVisible = false"
      :confirm-loading="loading">
      <a-form>
        <a-form-item>
          当前题目:<span v-html="currProblemTitle" />
          题目编码:{{ currProblemNodeStr }}
        </a-form-item>
        <a-form-item>
          <a-checkbox-group name="problem_ids" :default-value='changePreviewProblemForm.problem_ids'
            @change="changeSelectProblem">
            <a-table width="1000px" :dataSource="problemsList" :rowKey="item => 'se' + item.problems_id"
              :pagination="false" :loading="loading">
              <a-table-column key="select_problem" title="选择">
                <template slot-scope="item">
                  <a-checkbox :value="item.problems_id" />
                </template>
              </a-table-column>
              <a-table-column key="node_str" title="编码" data-index="node_str" />
              <a-table-column key="problems_title" title="题目标题">
                <template slot-scope="item">
                  <span v-html="item.problems_title" />
                </template>
              </a-table-column>
            </a-table>
          </a-checkbox-group>
        </a-form-item>
      </a-form>
    </a-modal>

  </div>
</template>

<script>
import OrPreview from "@/components/question/preview.vue";

export default {
  props: {
    item: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      questionList: [],
      showPreviewProblemsVisible: false,
      currProblemsList: [],
      problemsList: [],
      currProblemTitle: undefined,
      currProblemNodeStr: undefined,
      changePreviewProblemForm: {
        testpaper_id: undefined,
        problem_id: undefined,
        problem_ids: undefined
      }
    };
  },
  mounted() {
  },
  methods: {
    changeSelectProblem(problem_ids) {
      this.changePreviewProblemForm.problem_ids = problem_ids;
    },
    changePreviewProblem() {
      this.loading = true;
      this.$axios
        .post("/api/QuestionTestpaper/setPreviewExtendProblems", {
          data: {
            testpaper_id: this.changePreviewProblemForm.testpaper_id,
            problem_id: this.changePreviewProblemForm.problem_id,
            problem_ids: this.changePreviewProblemForm.problem_ids.join(",")
          }
        })
        .then(res => {
          this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.$success({
              title: "成功",
              content: "题目绑定完成",
              okText: "确定"
            });
            this.changePreviewProblemForm.problem_ids = undefined;
            this.showPreviewProblemsVisible = false;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    getPreviewExtendProblems(item) {
      this.loading = true;
      this.$axios
        .post("/api/QuestionTestpaper/getPreviewExtendProblems", {
          data: {
            testpaper_id: this.changePreviewProblemForm.testpaper_id,
            problem_id: item.id
          }
        })
        .then(res => {
          this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.currProblemTitle = item.title;
            this.currProblemNodeStr = item.node_str;
            this.changePreviewProblemForm.problem_id = item.id;
            this.problemsList = res.data.allProblemsList;
            if (res.data.currProblems) {
              this.changePreviewProblemForm.problem_ids = res.data.currProblems.split(",");
            }
            this.showPreviewProblemsVisible = true;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    selectItem(id) {
      this.exam.type = id;
    },
    selectGradeItem(id) {
      this.exam.grade_id = id;
    },
    selectSemesterItem(id) {
      this.exam.semester_id = id;
    },

    show() {
      this.changePreviewProblemForm.testpaper_id = this.item.id;
      this.$axios
        .post("/api/QuestionProblems/getproblemslist", {
          data: { testpaper_id: this.item.id }
        })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.questionList = res.data;
            for (let i = 0; i < this.questionList.length; i++) {
              if (this.questionList[i]["tag"] != "") {
                this.questionList[i]["tag"] = this.questionList[i][
                  "tag"
                ].split(",");
              }
            }

          }
        })
        .catch(err => {
          console.error(err);
        });
      this.visible = true;
    },
    handleOk() {
      this.visible = false;
    },
    handleCancel() {
      this.visible = false;
    },
    handleRemoveQuestion(item) {
      this.$emit("remove", item);
    }
  },
  watch: {},
  components: { OrPreview },
};
</script>

<style lang="less" scoped>
.inline {
  display: inline;
  margin-right: 1rem;
}

.option {
  display: flex;

  .label {
    font-weight: bold;
  }

  .span {
    width: 0;
    flex: 1;
    margin-left: 0.5rem;
  }
}
</style>